module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_office_color_black-00d07d82c22be8574536adf69b22ec9e.svg";